/* eslint-disable */
import Persister from '../../../utils/LocalStoragePersister';

const mutations = {
  setReports(state, value) {
    state.reportCards = value;
  },
  setReport(state, value) {
    state.reportCard = value;
  },
  setDateOfReport(state, value) {
    state.dateOfReport = value;
  },
  setReportCardOldState(state, value) {
    state.reportCardOldState = value;
  }
};

export default mutations;
